import React from "react";
import { useSelector } from "react-redux";

import { RootState } from "./redux/reducers";
import Navbar from "./app/Navbar/Navbar";
import Sidebar from "./app/Sidebar/Sidebar";
import { FreeTrialSnackBarModal } from "./app/FreeTrialSnackbarModal/FreeTrialSnackBarModal";

function WorkspaceLayout() {
  const websocket = useSelector(
    (state: RootState) => state.mainReducer.websocket,
  );
  const identityTrialLimits = useSelector(
    (state: RootState) => state.mainReducer.identity?.trialLimits,
  );
  return websocket ? (
    <>
      <Navbar />
      <Sidebar />
      {identityTrialLimits && <FreeTrialSnackBarModal />}
    </>
  ) : null;
}

export default WorkspaceLayout;
